import { render, staticRenderFns } from "./LicenseDetailsPage.vue?vue&type=template&id=fcb020d0&scoped=true&"
import script from "./LicenseDetailsPage.vue?vue&type=script&lang=js&"
export * from "./LicenseDetailsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb020d0",
  null
  
)

export default component.exports